import { render, staticRenderFns } from "./RetailPartner.vue?vue&type=template&id=a124f752"
import script from "./RetailPartner.vue?vue&type=script&lang=js"
export * from "./RetailPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports